import Vuex from 'vuex';
import Vue from 'vue';
import baseStore from '@/modules/index';
import bookings from '@/modules/bookings.module';
import availability from '@/modules/availability.module';
import offers from '@/modules/offers.module';
import company from '@/modules/company.module';
import auth from '@/modules/auth.module';
import tenant from '@/modules/tenant.module';
import professional from '@/modules/professional.module';
import invite from '@/modules/invite.module';
import message from '@/modules/message.module';

Vue.use(Vuex);

export default new Vuex.Store({
	...baseStore,
	modules: {
		bookings,
		availability,
		offers,
		company,
		auth,
		tenant,
		professional,
		invite,
		message,
	},
});
